<div class="lc-upload-progress" role="progressbar"
     [attr.aria-valuenow]="percent() ?? undefined"
     aria-valuemin="0"
     aria-valuemax="100"
     [attr.aria-label]="label()">
    <div class="lc-upload-progress__header">
        <span class="lc-upload-progress__label">{{ label() }}</span>
        @if (percentText(); as pct) {
            <span class="lc-upload-progress__percent">{{ pct }}</span>
        }
    </div>

    <div class="lc-upload-progress__track"
         [class.lc-upload-progress__track--indeterminate]="indeterminate()">
        <div class="lc-upload-progress__bar" [style.width]="widthStyle()"></div>
    </div>

    @if (showBytes()) {
        <div class="lc-upload-progress__bytes">
            {{ bytesText() }}
        </div>
    }
</div>
